import React, { useState } from "react";
import { message, Tooltip } from "antd";

// styles
import { 
  DivBotaoDownloadPlanilha,
  BotaoDownloadPlanilhas,
  ButtonTooltip
} from './styles';

// icons
import { CloudDownloadOutlined } from '@ant-design/icons'

function ModeloPlanilha() {
  const icmsModule = JSON.parse(sessionStorage.getItem("icmsModule"));
  const [isFetching, setFetching] = useState(false);

  const doGetPlanilhaRevendas = (e) => {
    const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj;
    const BASE_URL = icmsModule
    ? process.env.REACT_APP_APICLOUD_URL_ICMS
    : process.env.REACT_APP_APICLOUD_URL;

    setFetching(true);
    fetch(`${BASE_URL}/movimentacao/modelo/planilha/${cnpj}`, {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${sessionStorage.getItem("eRecuperadorJwt")}`,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          const fileName = `modelo-movimentacao-${cnpj}.xlsx`;

          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        }

        if (response.status === 400) {
          message.error("Não foi possível baixar a planilha de modelo");
        }
      })
      .catch(() => {
        message.error("Não foi possível baixar a planilha de modelo");
      })
      .finally(() => setFetching(false));
  };



  return (
      <DivBotaoDownloadPlanilha className="buttons-download">
        <Tooltip
          placement="top"
          title={
            <span>
              Este é o modelo de planilha para importação do cadastro de
              produtos
            </span>
          }
        >
          <BotaoDownloadPlanilhas
            className="btn-document mb-2"
            href={`https://cdn.e-auditoria.com.br/planilha-recuperador/${icmsModule ? "icms" : "piscofins"}/planilha-cadastro-de-produtos.xlsx?time=${new Date().getTime()}`}
            type="link"
            target="_blank"
            ghost
            download
            loading={isFetching}
          >
            Modelo de planilha para importação do cadastro de produtos
            <CloudDownloadOutlined />
          </BotaoDownloadPlanilhas>
        </Tooltip>

          <ButtonTooltip
            placement="top"
            title={
              <span>
                Este é o modelo de planilha para informar as revendas ocorridas no
                período de apuração.
              </span>
            }
          >
            <BotaoDownloadPlanilhas
              className="btn-document mb-3"
              type="link"
              ghost
              loading={isFetching}
              onClick={doGetPlanilhaRevendas}
            >
              Modelo de planilha para importação de Revendas no período de
              apuração
              <CloudDownloadOutlined />
            </BotaoDownloadPlanilhas>
          </ButtonTooltip>
      </DivBotaoDownloadPlanilha>
  );
}

export default ModeloPlanilha;